// The Task list's column contract: which columns exist, which are sortable, and
// which only apply to some site applications. It lives here rather than beside
// the table because the page's sort hook may not import components - it
// validates the stored sort against SORTABLE_COLUMN_IDS, so a column's
// sortability can't drift between the header and the sort restored on reload.
export const modelTaskColumnDefinitions = [
	// Wide enough for six status icons abreast (error, safety-critical,
	// parts, tools, permits, images/questions/documents) at ~20px + 5px gap
	// each - table-layout: fixed no longer lets this grow to fit a busy
	// row the way auto layout silently did, so it has to fit up front.
	{ id: "logo", label: () => "", sortable: false, width: "170px" },
	// The header's column id drives the sortField sent to the API, and "pos"
	// is the only Order-related value it accepts there. The row body (see
	// displayField below) renders "orderNumber" instead - the stable,
	// gap-free rank the API computes independent of the current sort.
	{ id: "pos", label: ({ t }) => t("label.order"), displayField: "orderNumber" },
	{ id: "actionName", label: ({ customCaptions }) => customCaptions?.actionRequired },
	{ id: "name", label: ({ t }) => t("label.name") },
	{
		id: "assets",
		label: ({ customCaptions }) => customCaptions?.asset,
		isVisible: ({ modelType }) => modelType === "F",
	},
	{
		id: "operatingModeName",
		label: ({ customCaptions }) => customCaptions?.operatingMode,
		isVisible: ({ showOperatingMode }) => Boolean(showOperatingMode),
	},
	{
		id: "systemName",
		label: ({ customCaptions }) => customCaptions?.system,
		isVisible: ({ showSystem }) => Boolean(showSystem),
	},
	{ id: "roles", label: ({ customCaptions }) => customCaptions?.rolePlural },
	{ id: "estimatedMinutes", label: ({ t }) => t("label.estMins") },
	{
		id: "intervals",
		label: ({ customCaptions }) => customCaptions?.intervalPlural,
		width: "100px",
	},
	{ id: "stages", label: ({ customCaptions }) => customCaptions?.stagePlural },
	{ id: "zones", label: ({ customCaptions }) => customCaptions?.zonePlural },
	{ id: "arrangements", label: ({ customCaptions }) => customCaptions?.arrangementPlural },
	// Most Tasks have no note, so TanStack's own value-sampled direction guess
	// keeps flipping between renders (it samples whatever's currently loaded) -
	// pinning the first click to ascending stops it from re-deciding itself.
	{ id: "notes", label: ({ t }) => t("label.notes"), sortDescFirst: false },
];

export const SORTABLE_COLUMN_IDS = new Set(
	modelTaskColumnDefinitions
		.filter((definition) => definition.sortable !== false)
		.map((definition) => definition.id)
);
